/** @format */

import {Table, TableCell, TableRow} from '@mui/material';
import {Trans} from 'react-i18next';

import {ActualKPI, StyledTableBody, StyledTableContainer, StyledTableHead} from '../../styles';
import ShowTypeIcon from '../ShowTypeIcon';
import {GenderAgeTableProps} from './interfaces';

const GenderAgeTable = ({data, showCorrection}: GenderAgeTableProps) => (
  <StyledTableContainer>
    <Table>
      <StyledTableHead>
        <TableRow>
          <TableCell>
            <Trans>Субаккаунт</Trans>
          </TableCell>
          <TableCell>
            <Trans>Тип кампании</Trans>
          </TableCell>
          <TableCell>
            <Trans>Пол</Trans>
          </TableCell>
          <TableCell>
            <Trans>Возраст</Trans>
          </TableCell>
          <TableCell>
            <Trans>Плановый KPI</Trans>
          </TableCell>
          <TableCell>
            <Trans>Фактический KPI</Trans>
          </TableCell>
          {showCorrection && (
            <TableCell>
              <Trans>Корректировка</Trans>
            </TableCell>
          )}
        </TableRow>
      </StyledTableHead>
      <StyledTableBody>
        {data.map((row, index) => (
          <TableRow key={index}>
            <TableCell>{row.subAccount}</TableCell>
            <TableCell>
              <ShowTypeIcon showType={row.showType} />
            </TableCell>
            <TableCell>{row.gender}</TableCell>
            <TableCell>{row.age}</TableCell>
            <TableCell>{row.plannedKPI}</TableCell>
            <TableCell>
              <ActualKPI>{row.actualKPI}</ActualKPI>
            </TableCell>
            {showCorrection && <TableCell>{row.correction}</TableCell>}
          </TableRow>
        ))}
      </StyledTableBody>
    </Table>
  </StyledTableContainer>
);

export default GenderAgeTable;
